import React, { useMemo } from 'react';
// @ts-ignore
import styles from './RecordMetaData.module.scss';
import I18n from '../../I18n/I18n/I18n';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import en from './locales/en.json';
import AdditionalIntl from '../../I18n/AdditionalIntl/AdditionalIntl';
var MESSAGES = normalizeLocaleData(en, '@dm/components.recordMetaData');
export default function RecordMetaData(_ref) {
  var allowSharing = _ref.allowSharing,
    originalSource = _ref.originalSource,
    lastSavedTime = _ref.lastSavedTime,
    createdTime = _ref.createdTime;
  var allowSharingI18n = useMemo(function () {
    return {
      id: '@dm/components.recordMetaData.metaData.sharing',
      values: {
        value: allowSharing
      }
    };
  }, [allowSharing]);
  var originalSourceI18n = useMemo(function () {
    return {
      id: '@dm/components.recordMetaData.metaData.original-source',
      values: {
        value: originalSource
      }
    };
  }, [originalSource]);
  var createdTimeI18n = useMemo(function () {
    return {
      id: '@dm/components.recordMetaData.metaData.created',
      values: {
        value: new Date(createdTime)
      }
    };
  }, [createdTime]);
  var lastSavedTimeI18n = useMemo(function () {
    return {
      id: '@dm/components.recordMetaData.metaData.last-saved',
      values: {
        value: new Date(lastSavedTime)
      }
    };
  }, [lastSavedTime]);
  return /*#__PURE__*/React.createElement(AdditionalIntl, {
    messages: MESSAGES,
    namespace: "@dm/components.recordMetaData"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, allowSharing && /*#__PURE__*/React.createElement("p", {
    className: styles['item']
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: allowSharingI18n
  })), originalSource && /*#__PURE__*/React.createElement("p", {
    className: styles['item']
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: originalSourceI18n
  })), createdTime && /*#__PURE__*/React.createElement("p", {
    className: styles['item']
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: createdTimeI18n
  })), lastSavedTime && /*#__PURE__*/React.createElement("p", {
    className: styles['item']
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: lastSavedTimeI18n
  }))));
}